import { useRef, useState } from 'react';
import { login, verifyTotp, saveSession, clearSession, getRole } from '../utils/auth';
import ManagerPanel from './ManagerPanel';

const inputStyle = {
  width: '100%', padding: '12px', border: '1px solid #ddd',
  borderRadius: '4px', fontSize: '16px', boxSizing: 'border-box',
};
const btnStyle = (loading) => ({
  width: '100%', padding: '12px', background: '#db782e', color: 'white',
  border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer',
  marginTop: '15px', opacity: loading ? 0.7 : 1,
});

const PrivateRoute = ({ children }) => {
  const [role, setRole]           = useState(getRole());
  const [password, setPassword]   = useState('');
  const [totpCode, setTotpCode]   = useState('');
  const [tempToken, setTempToken] = useState(null);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const totpRef = useRef(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await login(password);
      if (result.requireTotp) {
        setTempToken(result.tempToken);
        setTimeout(() => totpRef.current?.focus(), 50);
      } else {
        saveSession(result);
        setRole(result.role);
      }
    } catch {
      setError('Неверный пароль!');
    } finally {
      setLoading(false);
    }
  };

  const handleTotp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await verifyTotp(tempToken, totpCode);
      saveSession(result);
      setRole(result.role);
    } catch (err) {
      setError(err.message || 'Неверный код');
      setTotpCode('');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    clearSession();
    setRole(null);
  };

  if (role === 'admin' || role === 'admin2') return children;
  if (role === 'manager' || role === 'manager2') return <ManagerPanel onLogout={handleLogout} />;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', maxWidth: '400px', width: '100%' }}>
        {!tempToken ? (
          <>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>🔐 Вход</h2>
            <form onSubmit={handleLogin}>
              <input
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="Введите пароль"
                required
                style={inputStyle}
              />
              {error && <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>{error}</p>}
              <button type="submit" disabled={loading} style={btnStyle(loading)}>
                {loading ? 'Проверяем...' : 'Войти'}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 style={{ textAlign: 'center', marginBottom: '8px' }}>🔑 Двухфакторная аутентификация</h2>
            <p style={{ textAlign: 'center', color: '#666', fontSize: '14px', marginBottom: '20px' }}>
              Введите код из Google Authenticator
            </p>
            <form onSubmit={handleTotp}>
              <input
                ref={totpRef}
                type="text"
                inputMode="numeric"
                pattern="[0-9 ]*"
                value={totpCode}
                onChange={(e) => { setTotpCode(e.target.value); setError(''); }}
                placeholder="000 000"
                required
                autoComplete="one-time-code"
                style={{ ...inputStyle, textAlign: 'center', fontSize: '24px', letterSpacing: '6px' }}
              />
              {error && <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>{error}</p>}
              <button type="submit" disabled={loading} style={btnStyle(loading)}>
                {loading ? 'Проверяем...' : 'Подтвердить'}
              </button>
              <button
                type="button"
                onClick={() => { setTempToken(null); setPassword(''); setError(''); }}
                style={{ width: '100%', padding: '10px', background: 'none', border: 'none', color: '#999', fontSize: '14px', cursor: 'pointer', marginTop: '10px' }}
              >
                ← Назад
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default PrivateRoute;
